export default {
    section: 'Timeframe',
    name: 'offer-letter-timeframe',
    items: [
        {
            type: 'selectlist',
            text: 'Due Diligence Timeframe from Offer Letter Acceptance',
            name: 'offer-letter-timeframe-due-diligence',
            width: 3,
            props: {
                items: [
                    // TODO: Define values
                    {
                        text: 'swap-due-diligence',
                        value: 'swap-due-diligence'
                    }
                ]
            }
        },
        {
            type: 'datepicker',
            text: 'Deal Completed with Signed Contracts on or before',
            name: 'offer-letter-timeframe-deal-completed',
            width: 3,
            props: {}
        },
        {
            type: 'radio-list',
            text: 'Acceptance of Offer Letter',
            name: 'offer-letter-timeframe-acceptance',
            props: {
                row: true,
                items: [
                    // TODO: Verify that this is a yes/no question
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            }
        },
        {
            type: 'textarea',
            text: 'Notes',
            name: 'offer-letter-timeframe-notes',
            props: {}
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/timeframe.js